import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import icClose from '@iconify/icons-ic/twotone-close';
import icWarning from '@iconify/icons-ic/twotone-warning';
import icPerson from '@iconify/icons-ic/twotone-person';

export interface AffectationErrorModalData {
  message: string;
  userId: string;
}

@Component({
  selector: 'affectation-error-modal',
  templateUrl: './affectation-error-modal.component.html',
  styleUrls: ['./affectation-error-modal.component.scss'],
})
export class AffectationErrorModalComponent {
  icClose = icClose;
  icWarning = icWarning;
  icPerson = icPerson;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AffectationErrorModalData,
    public dialogRef: MatDialogRef<AffectationErrorModalComponent>,
    private router: Router,
  ) {}

  goToUserProfile() {
    // Naviguer vers la page du profil utilisateur
    this.router.navigate(['/management/user-profile', this.data.userId]);
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
